import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { SortOrder } from 'utils/sort-order/sort';

const initialRunbookTemplateMapping: Record<string, string> = {
  iac_vulerabilities: 'Infrastructure as Code',
  sast: 'SAST',
  secrets: 'Secrets',
  branch_protection: 'Branch Protection',
};

export type QueryBuilderState = {
  value: string;
  entity: 'repository' | 'identity';
} | null;
export interface BranchesState {
  activeSortedField: string;
  activeSortedOrder: SortOrder;
  activePolicySeverity: string;
  activeCustomStatus: string;
  policiesActiveTab: number;
  withDetections: boolean;
  runbookActiveTab: number;
  runbookTemplateMapping: Record<string, string>;
  queryBuilderState: QueryBuilderState;
}

const initialState: BranchesState = {
  activeSortedField: 'severity',
  activeSortedOrder: SortOrder.Desc,
  policiesActiveTab: 0,
  activeCustomStatus: 'all',
  activePolicySeverity: 'all',
  withDetections: false,
  runbookActiveTab: 0,
  runbookTemplateMapping: initialRunbookTemplateMapping,
  queryBuilderState: null,
};

export const branchesSlice = createSlice({
  name: 'branches',
  initialState,
  reducers: {
    setActiveSortedField: (
      state: BranchesState,
      action: PayloadAction<string>,
    ) => {
      state.activeSortedField =
        action.payload || initialState.activeSortedField;
    },
    setActiveSortedOrder: (
      state: BranchesState,
      action: PayloadAction<SortOrder>,
    ) => {
      state.activeSortedOrder = action.payload;
    },
    setPoliciesActiveTab: (
      state: BranchesState,
      action: PayloadAction<number>,
    ) => {
      state.policiesActiveTab = action.payload;
    },
    setActivePolicySeverity: (
      state: BranchesState,
      action: PayloadAction<string>,
    ) => {
      state.activePolicySeverity = action.payload;
    },
    setActiveCustomStatus: (
      state: BranchesState,
      action: PayloadAction<string>,
    ) => {
      state.activeCustomStatus = action.payload;
    },
    setWithDetections: (
      state: BranchesState,
      action: PayloadAction<boolean>,
    ) => {
      state.withDetections = action.payload;
    },
    setRunbookActiveTab: (
      state: BranchesState,
      action: PayloadAction<number>,
    ) => {
      state.runbookActiveTab = action.payload;
    },
    setRunbookTemplateMapping: (
      state: BranchesState,
      action: PayloadAction<Record<string, string>>,
    ) => {
      state.runbookTemplateMapping = action.payload;
    },
    setQueryBuilderState: (
      state: BranchesState,
      action: PayloadAction<QueryBuilderState>,
    ) => {
      state.queryBuilderState = action.payload;
    },
  },
});

export const {
  setActiveSortedField,
  setActiveSortedOrder,
  setPoliciesActiveTab,
  setActivePolicySeverity,
  setActiveCustomStatus,
  setWithDetections,
  setRunbookActiveTab,
  setRunbookTemplateMapping,
  setQueryBuilderState,
} = branchesSlice.actions;

export const branchesReducer = branchesSlice.reducer;
